import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, CATEGORIES } from "@/lib/api";
import NewsCard from "@/components/NewsCard";
import { Skeleton } from "@/components/ui/skeleton";

export default function Category() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const cat = CATEGORIES.find((c) => c.slug === slug);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const { data } = await api.get(`/articles?category=${slug}&limit=60`);
        setArticles(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  return (
    <div>
      <div className="border-b-2 border-primary pb-4 mb-8" data-testid="category-header">
        <div className="font-ui text-xs uppercase tracking-[0.3em] text-muted-foreground">
          Category · {cat?.en || slug}
        </div>
        <h1 className="font-kannada-heading text-4xl sm:text-5xl mt-1">
          {cat?.name || slug} <span className="text-primary">.</span>
        </h1>
      </div>

      {loading ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-72" />
          ))}
        </div>
      ) : articles.length === 0 ? (
        <div className="text-center py-24 text-muted-foreground font-kannada-body">
          ಈ ವಿಭಾಗದಲ್ಲಿ ಸದ್ಯಕ್ಕೆ ಯಾವುದೇ ಸುದ್ದಿ ಇಲ್ಲ.
        </div>
      ) : (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="category-grid">
          {articles.map((a, i) => (
            <NewsCard key={a.id} article={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
